import React from "react";
import MultiPartFieldUpdate from "./MultiPartFieldUpdate";

const MultiPartUpdate = (props) => {
  const { active, selection, onChange } = props;

  const handleSubmit = (event) => {
    event.preventDefault();
  };

  return (
    <div className={"modal" + (active ? " is-active" : "")}>
      <div className="modal-background"></div>
      <div className="modal-card">
        <div className="modal-card-head">
          <div className="modal-card-title">
            {`Editar ${selection.length} números de parte${
              selection.length === 1 ? "" : "s"
            }`}
          </div>
        </div>
        <div className="modal-card-body">
          <form onSubmit={handleSubmit}>
            <MultiPartFieldUpdate
              label="Status"
              type="part-status"
              field="status"
              selection={selection}
              onChange={onChange}
            />

            <MultiPartFieldUpdate
              label="Tiempo estimado de entrega"
              type="date"
              field="override_time"
              selection={selection}
              onChange={onChange}
            />

            <MultiPartFieldUpdate
              label="Orden de compra"
              type="text"
              field="purchase_order"
              selection={selection}
              onChange={onChange}
            />

            <MultiPartFieldUpdate
              label="Factura"
              type="invoice"
              field="invoice"
              selection={selection}
              onChange={onChange}
            />

            <MultiPartFieldUpdate
              label="Cargos adicionales"
              type="currency"
              field="additional_charges"
              selection={selection}
              onChange={onChange}
            />

            <MultiPartFieldUpdate
              label="Notas"
              type="text"
              field="notes"
              selection={selection}
              onChange={onChange}
            />

            <MultiPartFieldUpdate
              label="Notas Privadas"
              type="text"
              field="private_notes"
              selection={selection}
              onChange={onChange}
            />

            <div className="field is-grouped is-grouped-right">
              {props.onClose ? (
                <div className="control">
                  <button className="button is-text" onClick={props.onClose}>
                    Cerrar
                  </button>
                </div>
              ) : null}
            </div>
          </form>
        </div>
      </div>
      {props.onClose ? (
        <div className="modal-close is-large" onClick={props.onClose}></div>
      ) : null}
    </div>
  );
};

export default MultiPartUpdate;
